import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Award, ArrowRight, Clock } from "lucide-react";
import { API } from "@/lib/constants";

const BASIS_LABEL = {
  conversions: "Readers' top lead-driver this month",
  citations: "Most cited by AI assistants this month",
  latest: "Fresh off the press",
};

export const MostHelpfulArticle = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/conversions/top-article`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data?.post) return null;
  const { post, basis } = data;

  return (
    <section className="py-16 px-4" data-testid="most-helpful-section">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl border border-[#00E676]/20 bg-gradient-to-br from-[#00E676]/[0.06] via-black/40 to-transparent">
          <div className="grid md:grid-cols-5 items-stretch">
            <Link to={`/blog/${post.slug}`} className="md:col-span-2 block" data-testid="most-helpful-image-link">
              <img
                src={post.featured_image}
                alt={post.title}
                className="w-full h-52 md:h-full object-cover"
                loading="lazy"
              />
            </Link>
            <div className="md:col-span-3 p-7 md:p-9 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#00E676]/15 border border-[#00E676]/30 text-[#00E676] text-xs font-bold uppercase tracking-widest">
                  <Award className="w-3.5 h-3.5" /> Most Helpful This Month
                </span>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-3 leading-snug">
                <Link to={`/blog/${post.slug}`} className="hover:text-[#00E676] transition-colors" data-testid="most-helpful-title-link">
                  {post.title}
                </Link>
              </h2>
              <p className="text-gray-400 text-sm leading-relaxed mb-5 line-clamp-2">{post.excerpt}</p>
              <div className="flex flex-wrap items-center gap-4">
                <Link to={`/blog/${post.slug}`} data-testid="most-helpful-read-link" className="inline-flex items-center gap-2 text-[#00E676] font-semibold text-sm hover:gap-3 transition-all">
                  Read the guide <ArrowRight className="w-4 h-4" />
                </Link>
                <span className="text-gray-600 text-xs flex items-center gap-1">
                  <Clock className="w-3.5 h-3.5" /> {post.read_time} min read
                </span>
                <span className="text-gray-600 text-xs">{BASIS_LABEL[basis]}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MostHelpfulArticle;
